<script setup lang="ts">
import { onMounted, ref } from "vue";
import { isAuthenticated } from "@/shared/auth/isAuthenticated.helper";
import ColumnLayout from "@/shared/components/ColumnLayout/ColumnLayout.vue";
import ColumnLayoutBox from "@/shared/components/ColumnLayoutBox/ColumnLayoutBox.vue";
import mobilityRegistrationImage from "@/shared/images/mobility-registration.webp";
import MobilityRegistrationForm from "@/app/registration-app/user/mobility-registration/components/MobilityRegistrationForm/MobilityRegistrationForm.vue";
import SuccessfulRegistrationNote from "@/app/registration-app/user/mobility-registration/components/SuccessfulRegistrationNote/SuccessfulRegistrationNote.vue";
import HelpModal from "@/app/registration-app/user/mobility-registration/components/HelpModal/HelpModal.vue";
import { useRegisterMobilityUser } from "./useRegisterMobilityUser.composable";

const isHelpModalVisible = ref(false);
const userIsAuthenticated = ref(false);

onMounted(async () => {
  userIsAuthenticated.value = await isAuthenticated();
});

// --- Register User ---
const {
  isRegisteringMobilityUser,
  registeringMobilityUserError,
  onRegisteringMobilityUser,
  caseNumber,
} = useRegisterMobilityUser();
</script>

<template>
  <HelpModal
    :is-visible="isHelpModalVisible"
    @cancel="isHelpModalVisible = false"
  />
  <ColumnLayout :column-count="userIsAuthenticated ? 1 : 2">
    <template #column1>
      <ColumnLayoutBox>
        <SuccessfulRegistrationNote
          v-if="caseNumber && !isRegisteringMobilityUser"
          :case-number="caseNumber"
        />
        <MobilityRegistrationForm
          v-else
          :is-loading="isRegisteringMobilityUser"
          :has-error="!!registeringMobilityUserError"
          :show-back-button="!userIsAuthenticated"
          @register="onRegisteringMobilityUser"
          @open-help-modal="isHelpModalVisible = true"
        />
      </ColumnLayoutBox>
    </template>
    <template #column2>
      <img
        class="mobility-registration-view--image"
        :src="mobilityRegistrationImage"
        :alt="$t('registration.user.mobility.title')"
      />
    </template>
  </ColumnLayout>
</template>
<style scoped>
@import "MobilityRegistrationView.css";
</style>
